export default "__VITE_ASSET__ByM6$pGA__"